import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for /client/assessments/:assessmentId/:assignmentId/*. Renders
 * <Outlet /> so the index route (take screen) and the `/result` child can
 * mount here. Without this layout the result child would never render
 * because TanStack Router treats sibling dot-segmented files as parent ↔
 * child, and the take screen never had an Outlet.
 */
export const Route = createFileRoute('/client/assessments/$assessmentId/$assignmentId')({
  component: ClientAssessmentTakeLayout,
});

function ClientAssessmentTakeLayout() {
  return <Outlet />;
}
